import React, { Component } from 'react';
import Base from '../rebase';
import { PageHeader } from 'react-bootstrap';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      header: {},
    };
  }

  componentWillMount() {
    this.ref = Base.bindToState('header', {
      context: this,
      state: 'header',
      asArray: false
    })
  }

  render() {
  	return(
  		<div>
  			<PageHeader className="text-center">
  				{this.state.header.primary}<br />
  				<small>
  					{this.state.header.secondary}
  				</small>
  			</PageHeader>
  		</div>
  	)
  }

}

export default Header;


// WEBPACK FOOTER //
// ./src/reusable_components/Header.jsx